/** InsCoder 2026-03-28 B + Equalize no-usf collection card heights **/
(function () {
  if (window.__noUsfCollectionEqualizeInit) {
    return;
  }

  window.__noUsfCollectionEqualizeInit = true;

  var GRID_SELECTOR = '[data-no-usf-grid]';
  var OBSERVER_ROOT_SELECTOR = '#CollectionAjaxContent';
  var ITEM_SELECTOR = '.grid__item';
  var CARD_SELECTOR = '.grid-product__content';
  var IMAGE_SELECTOR = 'img';
  var VIEW_SWITCH_SELECTOR = '[data-no-usf-view-switches]';
  var VIEW_BUTTON_SELECTOR = '[data-no-usf-view]';
  var VIEW_STORAGE_KEY = 'noUsfCollectionView';
  var LIST_VIEW_CLASS = 'no-usf-view-list';
  var LOAD_MORE_BUTTON_SELECTOR = '[data-load-more-button]';
  var LOAD_MORE_PAGINATION_SELECTOR = '[data-load-more-pagination]';
  var equalizeFrame = null;
  var observer = null;

  function getStoredView() {
    var storedView = null;
    try {
      storedView = window.localStorage.getItem(VIEW_STORAGE_KEY);
    } catch (e) {}

    if (storedView === 'grid' || storedView === 'list') {
      return storedView;
    }

    return 'grid';
  }

  function storeView(view) {
    try {
      window.localStorage.setItem(VIEW_STORAGE_KEY, view);
    } catch (e) {}
  }

  function applyViewState(root, view) {
    var grid = root.querySelector(GRID_SELECTOR);
    if (!grid) {
      return;
    }

    if (view === 'grid') {
      grid.classList.remove(LIST_VIEW_CLASS);
    } else {
      grid.classList.add(LIST_VIEW_CLASS);
    }

    root.querySelectorAll(VIEW_BUTTON_SELECTOR).forEach(function (button) {
      var isActive = button.dataset.noUsfView === view;
      button.classList.toggle('usf-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    scheduleEqualize();
  }

  function initViewSwitches(scope) {
    scope.querySelectorAll(VIEW_SWITCH_SELECTOR).forEach(function (switcher) {
      var root = switcher.closest('.collection-grid__wrapper');
      if (!root) {
        return;
      }

      applyViewState(root, getStoredView());

      switcher.querySelectorAll(VIEW_BUTTON_SELECTOR).forEach(function (button) {
        if (button.dataset.noUsfViewBound === 'true') {
          return;
        }

        button.dataset.noUsfViewBound = 'true';
        button.addEventListener('click', function () {
          var view = button.dataset.noUsfView;
          if (view !== 'grid' && view !== 'list') {
            return;
          }

          storeView(view);
          applyViewState(root, view);
        });
      });
    });
  }

  function getRows(cards) {
    var rows = [];

    cards.forEach(function (card) {
      var rect = card.getBoundingClientRect();
      var row = rows.find(function (entry) {
        return Math.abs(entry.top - rect.top) < 2;
      });

      if (!row) {
        row = { top: rect.top, cards: [] };
        rows.push(row);
      }

      row.cards.push(card);
    });

    return rows;
  }

  function resetCardHeights(cards) {
    cards.forEach(function (card) {
      card.style.minHeight = '';
    });
  }

  function resetItemHeights(items) {
    items.forEach(function (item) {
      item.style.minHeight = '';
    });
  }

  function equalizeRows(items) {
    getRows(items).forEach(function (row) {
      var maxHeight = 0;

      row.cards.forEach(function (item) {
        maxHeight = Math.max(maxHeight, item.offsetHeight);
      });

      row.cards.forEach(function (item) {
        item.style.minHeight = maxHeight + 'px';
      });
    });
  }

  function equalizeGrid(grid) {
    var items = Array.prototype.slice.call(grid.querySelectorAll(ITEM_SELECTOR));
    var cards = Array.prototype.slice.call(grid.querySelectorAll(CARD_SELECTOR));

    if (!cards.length || !items.length) {
      return;
    }

    resetCardHeights(cards);
    resetItemHeights(items);

    if (window.innerWidth >= 769 && grid.classList.contains(LIST_VIEW_CLASS)) {
      return;
    }

    equalizeRows(cards);
    equalizeRows(items);
  }

  function bindGridImages(grid) {
    grid.querySelectorAll(IMAGE_SELECTOR).forEach(function (image) {
      if (image.dataset.noUsfEqualizeBound === 'true') {
        return;
      }

      image.dataset.noUsfEqualizeBound = 'true';
      image.addEventListener('load', scheduleEqualize);
      image.addEventListener('error', scheduleEqualize);
    });
  }

  function equalizeAll() {
    var grids = document.querySelectorAll(GRID_SELECTOR);

    grids.forEach(function (grid) {
      bindGridImages(grid);
      equalizeGrid(grid);
    });
  }

  function scheduleEqualize() {
    if (equalizeFrame) {
      window.cancelAnimationFrame(equalizeFrame);
    }

    equalizeFrame = window.requestAnimationFrame(function () {
      equalizeFrame = null;
      equalizeAll();
    });
  }

  function setupObserver() {
    var root = document.querySelector(OBSERVER_ROOT_SELECTOR);

    if (!('MutationObserver' in window) || !root) {
      return;
    }

    if (!observer) {
      observer = new MutationObserver(scheduleEqualize);
    } else {
      observer.disconnect();
    }

    observer.observe(root, { childList: true, subtree: true });
  }

  /** InsCoder 2026-06-12 B + Load more pagination **/
  function loadMoreProducts(button) {
    if (button.dataset.loading === 'true') {
      return;
    }

    var section = button.closest('#CollectionSection');
    var currentGrid = section ? section.querySelector(GRID_SELECTOR) : null;
    var currentPagination = button.closest(LOAD_MORE_PAGINATION_SELECTOR);

    if (!section || !currentGrid || !currentPagination || !button.href) {
      if (button.href) {
        window.location.assign(button.href);
      }
      return;
    }

    button.dataset.loading = 'true';
    button.setAttribute('aria-busy', 'true');

    fetch(button.href, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to load the next collection page.');
        }

        return response.text();
      })
      .then(function (html) {
        var nextDocument = new DOMParser().parseFromString(html, 'text/html');
        var nextSection = nextDocument.querySelector('#CollectionSection');
        var nextGrid = nextSection ? nextSection.querySelector(GRID_SELECTOR) : null;
        var nextPagination = nextSection ? nextSection.querySelector(LOAD_MORE_PAGINATION_SELECTOR) : null;

        if (!nextGrid) {
          throw new Error('The next collection page does not contain a product grid.');
        }

        Array.prototype.slice.call(nextGrid.children).forEach(function (item) {
          currentGrid.appendChild(item);
        });

        if (nextPagination) {
          currentPagination.replaceWith(nextPagination);
        } else {
          currentPagination.remove();
        }

        if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
          window.theme.reinitProductGridItem();
        }

        document.dispatchEvent(new CustomEvent('collection:reloaded'));
        scheduleEqualize();
      })
      .catch(function () {
        window.location.assign(button.href);
      });
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) {
      return;
    }

    var button = event.target.closest(LOAD_MORE_BUTTON_SELECTOR);

    if (!button || !button.closest('#CollectionSection')) {
      return;
    }

    event.preventDefault();
    loadMoreProducts(button);
  });
  /** InsCoder 2026-06-12 E + Load more pagination **/

  document.addEventListener('DOMContentLoaded', scheduleEqualize);
  document.addEventListener('DOMContentLoaded', function () {
    initViewSwitches(document);
  });
  document.addEventListener('DOMContentLoaded', setupObserver);
  document.addEventListener('collection:reloaded', function () {
    initViewSwitches(document);
  });
  document.addEventListener('shopify:section:load', scheduleEqualize);
  document.addEventListener('shopify:section:load', setupObserver);
  document.addEventListener('page:loaded', scheduleEqualize);
  document.addEventListener('page:loaded', setupObserver);
  window.addEventListener('resize', scheduleEqualize);
  window.addEventListener('load', scheduleEqualize);
  window.addEventListener('load', setupObserver);
})();
/** InsCoder 2026-03-28 E + Equalize no-usf collection card heights **/
